import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { SberIdUserInfo } from 'Pages/lead'

interface InitialState {
	one: SberIdUserInfo | null
}

const initialState: InitialState = {
	one: null,
}

export namespace SberIdUserInfoNS {
	export type SetOne = PayloadAction<SberIdUserInfo>
	export type GetSberIdUserInfo = PayloadAction<number>
	export type ClearOne = PayloadAction
}
// TODO отвязаться, перенести в модуль
export const sberIdUserInfoSlice = createSlice({
	name: 'sberIdUserInfo',
	initialState,
	reducers: {
		setOne: (state, action: SberIdUserInfoNS.SetOne) => {
			state.one = action.payload
		},
		getSberIdUserInfo: (state, action: SberIdUserInfoNS.GetSberIdUserInfo) => {},
		clearOne: (state, action: SberIdUserInfoNS.ClearOne) => {
			state.one = null
		},
	},
})
